export default {
  // 按模板导出付款申请单 PDF。
  exportPaymentApplicationPdf: '/ygsjzs/yxUserDepositNew/exportPaymentApplicationPdf',
  // 新增充值退还记录
  insertYxUserDepositRecord: '/ygsjzs/yxUserDepositRecord/insertYxUserDepositRecord',
  insertYxUserJrRecord: '/ygsjzs/yxUserDepositRecord/insertYxUserJrRecord',
  // 审批充值退还记录
  approvaYxUserDepositRecord: '/ygsjzs/yxUserDepositRecord/approvaYxUserDepositRecord',
  // 物理删除充值退还记录
  deleteDataYxUserDepositRecord: '/ygsjzs/yxUserDepositRecord/deleteDataYxUserDepositRecord',

  // 查询充值退还记录详情
  selectYxUserDepositRecordByDepositId: '/ygsjzs/yxUserDepositRecord/selectYxUserDepositRecordByDepositId',
  // 分页查询充值退还记录列表
  selectYxUserDepositRecordByPage: '/ygsjzs/yxUserDepositRecord/selectYxUserDepositRecordByPage',

  // 货款的充值
  insertYxUserGoodsRecord: '/ygsjzs/yxUserGoodsRecord/insertYxUserGoodsRecord',
  approvaYxUserGoodsRecord: '/ygsjzs/yxUserGoodsRecord/approvaYxUserGoodsRecord',
  deleteDataYxUserGoodsRecord: '/ygsjzs/yxUserGoodsRecord/deleteDataYxUserGoodsRecord',
  selectYxUserGoodsRecordByGoodsId: '/ygsjzs/yxUserGoodsRecord/selectYxUserGoodsRecordByGoodsId',
  selectYxUserGoodsRecordByPage: '/ygsjzs/yxUserGoodsRecord/selectYxUserGoodsRecordByPage',
  // 快捷充值
  insertYxUserAllDepositRecord: '/ygsjzs/yxUserDepositRecord/insertYxUserAllDepositRecord',

  // 新版充值管理
  insertYxUserDepositNew: '/ygsjzs/yxUserDepositNew/insertYxUserDepositNew',
  updateYxUserDepositNew: '/ygsjzs/yxUserDepositNew/updateYxUserDepositNew',
  approvaYxUserDepositNew: '/ygsjzs/yxUserDepositNew/approvaYxUserDepositNew',
  deleteDataYxUserDepositNew: '/ygsjzs/yxUserDepositNew/deleteDataYxUserDepositNew',
  selectYxUserDepositNewByDepositId: '/ygsjzs/yxUserDepositNew/selectYxUserDepositNewByDepositId',
  selectYxUserDepositNewByList: '/ygsjzs/yxUserDepositNew/selectYxUserDepositNewByList',
  txUserDepositNewToPdf: '/ygsjzs/yxUserDepositNew/txUserDepositNewToPdf',

  exportYxDepositNew: '/ygsjzs/yxUserDepositNew/exportYxDepositNew'
}
